var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      style: {
        margin: _vm.isExternal ? "0" : "20px",
        borderRadius: _vm.isExternal ? "0" : "5px",
      },
    },
    [
      !_vm.isExternal
        ? _c(
            "w-card-title",
            { style: { padding: "15px" } },
            [
              _vm._v(" Ticket " + _vm._s(_vm.ticket.id) + " "),
              _c("div", { staticClass: "version" }, [
                _vm._v(_vm._s(_vm.company.tierAsString)),
              ]),
              _c("w-spacer"),
              _c(
                "w-link",
                { style: { color: "#fff" }, attrs: { to: _vm.ticketLink } },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.ready
        ? _c(
            "w-card-content",
            {
              style: {
                height: "calc(100vh - 100px)",
                padding: "5px",
                display: "flex",
              },
            },
            [
              _c(
                "w-row",
                { attrs: { grow: "", shrink: "" } },
                [
                  _c(
                    "w-col",
                    {
                      style: { flexGrow: 1, flexShrink: 0 },
                      attrs: { lg: "8", sm: "8", xl: "9" },
                    },
                    [
                      _c(
                        "w-card",
                        {
                          style: { flexGrow: 1, maxHeight: "100%" },
                          nativeOn: {
                            dragenter: function ($event) {
                              return _vm.onDragStart()
                            },
                            dragleave: function ($event) {
                              return _vm.onDragEnd()
                            },
                            drop: function ($event) {
                              $event.preventDefault()
                              return _vm.onFileDrop($event)
                            },
                          },
                        },
                        [
                          _c(
                            "w-card-title",
                            { style: { padding: "5px 20px" } },
                            [
                              _c(
                                "div",
                                { staticClass: "home-wrap" },
                                [
                                  _c(
                                    "w-link",
                                    { attrs: { to: _vm.ticketLink } },
                                    [_c("w-fa", { attrs: { icon: "home" } })],
                                    1
                                  ),
                                  _c("app-ticket-next-and-previous-buttons"),
                                ],
                                1
                              ),
                              _c("w-spacer"),
                              _c(
                                "div",
                                { staticClass: "watchers" },
                                _vm._l(
                                  _vm.openAdminList,
                                  function (openedAdmin) {
                                    return _c(
                                      "span",
                                      {
                                        key: openedAdmin.id,
                                        staticClass: "mr",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(openedAdmin.name) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c("app-ticket-pin-button", {
                                staticClass: "ml",
                                attrs: { ticket: _vm.ticket },
                              }),
                              _c("app-ticket-bookmark-button", {
                                staticClass: "ml",
                                attrs: { ticket: _vm.ticket },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-card-title",
                            { staticClass: "subject" },
                            [
                              _c(
                                "w-row",
                                { attrs: { center: "" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.ticket.subject) + " "
                                  ),
                                  _c(
                                    "w-link",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Titel wijziggen",
                                          expression: "'Titel wijziggen'",
                                        },
                                      ],
                                      staticClass: "ml",
                                      on: {
                                        click: function ($event) {
                                          _vm.editSubjectModal = true
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "pen" } })],
                                    1
                                  ),
                                  _c("w-spacer"),
                                  _c(
                                    "w-link",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.showInitialMessage =
                                            !_vm.showInitialMessage
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass: "ml",
                                        attrs: {
                                          icon: _vm.showInitialMessage
                                            ? "chevron-down"
                                            : "chevron-up",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.showInitialMessage
                                ? _c("pre", {
                                    directives: [
                                      {
                                        name: "safe-html",
                                        rawName: "v-safe-html",
                                        value: _vm.ticketDescription,
                                        expression: "ticketDescription",
                                      },
                                    ],
                                    staticClass: "message",
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "w-scroll-view",
                            {
                              ref: "messagesContainer",
                              staticClass: "messages",
                              style: { flexGrow: 1 },
                            },
                            [
                              _vm.hasReadTicketMessage
                                ? _c("w-row", [
                                    _c(
                                      "div",
                                      { staticClass: "after-message-item" },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "check" },
                                        }),
                                        _vm._v(
                                          " Gebruiker heeft het laatste bericht gelezen. "
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._l(
                                _vm.ticket.messages.slice().reverse(),
                                function (msg) {
                                  return _c("app-ticket-message", {
                                    key: msg.id,
                                    ref: "messages",
                                    refInFor: true,
                                    attrs: {
                                      ticket: _vm.ticket,
                                      updating: msg.id == _vm.updatingMessageId,
                                      value: msg,
                                    },
                                    on: {
                                      "reply-to": function ($event) {
                                        return _vm.onReplyToClicked($event)
                                      },
                                      setFocusToTextArea: function ($event) {
                                        return _vm.setFocusOnTextArea()
                                      },
                                      updateAttentions: function ($event) {
                                        return _vm.updateAttentions($event)
                                      },
                                      updatingChange: function ($event) {
                                        return _vm.onUpdatingChange(msg, $event)
                                      },
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                          _c("w-card-actions", { staticClass: "text-box" }, [
                            _c(
                              "div",
                              {
                                staticClass: "chip-box",
                                style: {
                                  flexGrow: 1,
                                  display: "flex",
                                  position: "relative",
                                  width: "100%",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "make-public",
                                    class: _vm.supportWarning,
                                  },
                                  [
                                    _c("w-checkbox", {
                                      staticClass: "mr",
                                      attrs: {
                                        label: "Verstuur bericht naar klant",
                                      },
                                      model: {
                                        value: _vm.isPublic,
                                        callback: function ($$v) {
                                          _vm.isPublic = $$v
                                        },
                                        expression: "isPublic",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("w-spacer"),
                                _c(
                                  "div",
                                  {
                                    style: {
                                      position: "relative",
                                      paddingRight: "5px",
                                      margin: "0 20px 0 30px",
                                    },
                                  },
                                  [
                                    _c(
                                      "w-link",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.attentionModal = true
                                          },
                                        },
                                      },
                                      [
                                        _vm.attentions.length > 0 &&
                                        !_vm.editAttentions
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "attentions-badge",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.attentions.length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" Attentie vragen "),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { style: { marginRight: "52px" } },
                                  [
                                    _c("app-ticket-message-actions", {
                                      attrs: { ticket: _vm.ticket },
                                      on: {
                                        input: function ($event) {
                                          return _vm.triggerAction($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "input-box",
                                style: {
                                  flexGrow: 1,
                                  display: "flex",
                                  position: "relative",
                                  width: "100%",
                                  alignItems: "flex-end",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      position: "relative",
                                      flexGrow: 1,
                                      display: "flex",
                                    },
                                  },
                                  [
                                    _c("textarea", {
                                      ref: "textarea",
                                      class: _vm.textareaClass,
                                      style: { flexGrow: 1, height: "20px" },
                                      attrs: {
                                        placeholder:
                                          _vm.externalOrInternalMessageTooltip,
                                      },
                                      domProps: { value: _vm.content },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onTextAreaInput($event)
                                        },
                                        paste: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onTextAreaPaste($event)
                                        },
                                        keyup: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            if (
                                              $event.ctrlKey ||
                                              $event.shiftKey ||
                                              $event.altKey ||
                                              $event.metaKey
                                            )
                                              return null
                                            return _vm.autoExpand()
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            if (!$event.ctrlKey) return null
                                            if (
                                              $event.shiftKey ||
                                              $event.altKey ||
                                              $event.metaKey
                                            )
                                              return null
                                            _vm.content += "\n"
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "up",
                                                38,
                                                $event.key,
                                                ["Up", "ArrowUp"]
                                              )
                                            )
                                              return null
                                            if (
                                              $event.ctrlKey ||
                                              $event.shiftKey ||
                                              $event.altKey ||
                                              $event.metaKey
                                            )
                                              return null
                                            return _vm.upKeyPressed()
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            if (!$event.ctrlKey) return null
                                            $event.preventDefault()
                                            return _vm.sendResponse.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        ],
                                        keydown: function ($event) {
                                          if (!$event.ctrlKey) return null
                                          if (
                                            $event.shiftKey ||
                                            $event.altKey ||
                                            $event.metaKey
                                          )
                                            return null
                                          return _vm.onTextInputCtrlKeyDown(
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("w-fa", {
                                      staticClass: "expand",
                                      attrs: { icon: "expand" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.expand(!_vm.isExpanded)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("input", {
                                  ref: "fileInput",
                                  staticClass: "file-input",
                                  attrs: { type: "file" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onFileInput($event)
                                    },
                                  },
                                }),
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Boodschap verzenden",
                                        expression: "'Boodschap verzenden'",
                                      },
                                    ],
                                    style: { marginBottom: "1px" },
                                    attrs: { flat: "", lg: "", round: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sendResponse()
                                      },
                                    },
                                  },
                                  [
                                    _c("w-fa", {
                                      attrs: { icon: "paper-plane" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm.showDropOverlay
                            ? _c("div", { staticClass: "drop-overlay" }, [
                                _c(
                                  "div",
                                  [
                                    _c("w-fa", {
                                      attrs: {
                                        icon: "file-upload",
                                        size: "8x",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", [_vm._v(" DROP FILES TOP UPLOAD ")]),
                              ])
                            : _vm._e(),
                          _c(
                            "w-modal",
                            {
                              attrs: { "escape-close": "" },
                              model: {
                                value: _vm.attentionModal,
                                callback: function ($$v) {
                                  _vm.attentionModal = $$v
                                },
                                expression: "attentionModal",
                              },
                            },
                            [
                              _c(
                                "w-card",
                                {
                                  staticStyle: { "flex-grow": "1" },
                                  attrs: { "max-width": "700" },
                                },
                                [
                                  _c("w-card-title", [
                                    _vm._v("Attentie vragen"),
                                  ]),
                                  _c(
                                    "w-card-content",
                                    [
                                      _c(
                                        "w-scroll-view",
                                        { attrs: { tag: "div" } },
                                        [
                                          _c("app-admin-checkboxes-select", {
                                            attrs: { fancy: "" },
                                            model: {
                                              value: _vm.attentions,
                                              callback: function ($$v) {
                                                _vm.attentions = $$v
                                              },
                                              expression: "attentions",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-card-actions",
                                    [
                                      _c(
                                        "w-button",
                                        {
                                          staticClass: "cancel",
                                          on: {
                                            click: function ($event) {
                                              ;(_vm.editAttentions = 0),
                                                (_vm.attentionModal = false)
                                            },
                                          },
                                        },
                                        [_vm._v(" Annulerenx ")]
                                      ),
                                      _c("w-spacer"),
                                      _vm.editAttentions
                                        ? _c(
                                            "w-button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.saveAttentions(),
                                                    (_vm.attentionModal = false)
                                                },
                                              },
                                            },
                                            [_vm._v(" Attenties updaten ")]
                                          )
                                        : _c(
                                            "w-button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.attentionModal = false
                                                },
                                              },
                                            },
                                            [_vm._v(" Sluiten ")]
                                          ),
                                      _vm.content
                                        ? _c(
                                            "w-button",
                                            {
                                              staticClass: "ml",
                                              on: {
                                                click: function ($event) {
                                                  ;(_vm.attentionModal = false),
                                                    _vm.sendResponse()
                                                },
                                              },
                                            },
                                            [_vm._v(" Bericht verzenden ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.ticket.company
                    ? _c(
                        "w-col",
                        {
                          style: { flexGrow: 1, flexShrink: 0 },
                          attrs: { lg: "4", sm: "4", xl: "3" },
                        },
                        [
                          _c(
                            "w-scroll-view",
                            [
                              _vm.showOptions && !_vm.toggleCrm
                                ? _c("w-row", [
                                    _c(
                                      "div",
                                      { staticClass: "boxed" },
                                      [
                                        _c(
                                          "w-col",
                                          { attrs: { xs: "12" } },
                                          [
                                            _c(
                                              "w-row",
                                              { staticClass: "company-name" },
                                              [
                                                _c(
                                                  "w-link",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value:
                                                          "Account instellingen",
                                                        expression:
                                                          "'Account instellingen'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      target: "_blank",
                                                      to:
                                                        "/companies/" +
                                                        _vm.ticket.company.id +
                                                        "/edit",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.ticket.company
                                                            .name
                                                            ? _vm.ticket.company
                                                                .name
                                                            : _vm.ticket.client
                                                            ? _vm.ticket.client
                                                                .firstname +
                                                              " " +
                                                              _vm.ticket.client
                                                                .lastname
                                                            : ""
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("w-spacer"),
                                                _vm.ticket.client
                                                  ? _c(
                                                      "app-login-as-user-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value:
                                                              "Aanmelden als admin",
                                                            expression:
                                                              "'Aanmelden als admin'",
                                                          },
                                                        ],
                                                        staticClass: "mr",
                                                        attrs: {
                                                          admin: "",
                                                          user: _vm.ticket
                                                            .client,
                                                        },
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          attrs: {
                                                            icon: "headset",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.ticket.client
                                                  ? _c(
                                                      "app-login-as-user-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value:
                                                              "Aanmelden als klant",
                                                            expression:
                                                              "'Aanmelden als klant'",
                                                          },
                                                        ],
                                                        attrs: {
                                                          user: _vm.ticket
                                                            .client,
                                                        },
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          attrs: {
                                                            icon: "sign-in-alt",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm.ticket.client
                                              ? _c(
                                                  "w-row",
                                                  {
                                                    staticClass: "client-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.ticket.client
                                                            .firstname
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.ticket.client
                                                            .lastname
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.dossierName
                                              ? _c(
                                                  "w-row",
                                                  {
                                                    staticClass: "client-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Dossier " +
                                                        _vm._s(
                                                          _vm.dossierName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "w-row",
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "w-link sm",
                                                    attrs: {
                                                      href: _vm.allTicketsURL,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.allTicketsText
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("w-spacer"),
                                                _c(
                                                  "w-link",
                                                  {
                                                    staticClass: "sm",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.toggleCrm = true
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("CRM info")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("w-row", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "w-link sm",
                                                  attrs: {
                                                    href:
                                                      "http://cloud.winfakt.be/admin/crm/app/klanten/detail?wwnr=" +
                                                      _vm.company.WfOfflineID +
                                                      "&view=klant_verkoop&clean=1",
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Verkoopsoverzicht bekijken"
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm.company
                                              ? _c(
                                                  "w-col",
                                                  {
                                                    staticClass: "labels",
                                                    attrs: {
                                                      "no-margin": "",
                                                      xs: "12",
                                                    },
                                                  },
                                                  [
                                                    _vm.company.owner
                                                      ? _c(
                                                          "w-row",
                                                          [
                                                            _vm._v(" Email "),
                                                            _vm.company.owner
                                                              .activated
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    style: {
                                                                      margin:
                                                                        "0px 4px",
                                                                      color:
                                                                        "green",
                                                                    },
                                                                  },
                                                                  [_vm._v("✓")]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(": "),
                                                            _c("w-spacer"),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.company
                                                                    .owner.email
                                                                ) +
                                                                " "
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "w-row",
                                                      [
                                                        _vm._v(" Telefoon: "),
                                                        _c("w-spacer"),
                                                        _c("div", {
                                                          directives: [
                                                            {
                                                              name: "safe-html",
                                                              rawName:
                                                                "v-safe-html",
                                                              value: _vm.phones,
                                                              expression:
                                                                "phones",
                                                            },
                                                          ],
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "w-row",
                                                      [
                                                        _vm._v(" Actief tot: "),
                                                        _c("w-spacer"),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.company
                                                                .activeUntilString
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "w-row",
                                                      {
                                                        class: {
                                                          demo: _vm.company
                                                            .isDemo,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" Editie: "),
                                                        _c("w-spacer"),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.company
                                                                .tierAsString
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm.blocked
                                                      ? _c(
                                                          "w-row",
                                                          {
                                                            staticClass: "warn",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " KLANT IS GEBLOKKEERD "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "w-row",
                                                      {
                                                        class:
                                                          _vm.supportWarning,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Service Pack tot: "
                                                        ),
                                                        _c("w-spacer"),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.company
                                                                .servicePackString
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "w-row",
                                                      [
                                                        _vm._v(" Modules: "),
                                                        _c("w-spacer"),
                                                        _c(
                                                          "w-button",
                                                          {
                                                            staticClass:
                                                              "smallTicketIcons",
                                                            attrs: { flat: "" },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showModules()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "eye",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "boxed" },
                                      [
                                        _c("h4", [_vm._v("Peppol status")]),
                                        _c("w-row", [
                                          _vm.isPeppolActive
                                            ? _c(
                                                "span",
                                                { staticClass: "active" },
                                                [_vm._v("Peppol is actief")]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "not-active" },
                                                [
                                                  _vm._v(
                                                    "Peppol is niet actief"
                                                  ),
                                                ]
                                              ),
                                        ]),
                                        _c(
                                          "w-row",
                                          [
                                            _vm.showPeppolActivateButton
                                              ? _c(
                                                  "w-button",
                                                  {
                                                    staticClass: "mts",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.showPeppolActivationModal = true
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Peppol activeren")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "boxed" },
                                      [
                                        _c(
                                          "w-col",
                                          {
                                            attrs: {
                                              "no-margin": "",
                                              xs: "12",
                                            },
                                          },
                                          [
                                            _c(
                                              "h4",
                                              [
                                                _c(
                                                  "w-row",
                                                  [
                                                    _c(
                                                      "w-link",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value:
                                                              "Open deze in nieuwe tab",
                                                            expression:
                                                              "'Open deze in nieuwe tab'",
                                                          },
                                                        ],
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openTicket()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Ticket " +
                                                            _vm._s(
                                                              _vm.ticket.id
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "w-link",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value:
                                                              "Ticket-link kopiëren",
                                                            expression:
                                                              "'Ticket-link kopiëren'",
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          staticClass: "w-link",
                                                          style: {
                                                            margin:
                                                              "0px 0 0 5px",
                                                          },
                                                          attrs: {
                                                            icon: "copy",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.copyLink()
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c("w-spacer"),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.ticket.getTimeCreatedString()
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "w-row",
                                              [
                                                _vm._v(" Intern: "),
                                                _c("w-spacer"),
                                                _c(
                                                  "w-link",
                                                  {
                                                    attrs: {
                                                      tooltip:
                                                        "Zichtbaarheid ticket aanpassen",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleTicketIsVisibleForClient()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.internalText
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "w-row",
                                              [
                                                _vm._v(" Datum planning: "),
                                                _c("w-spacer"),
                                                _c(
                                                  "w-link",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editTimeSheduled()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getTimeSheduled
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "w-row",
                                              [
                                                _vm._v(" Gelezen door klant: "),
                                                _c("w-spacer"),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.hasReadTicketMessage
                                                        ? "Ja"
                                                        : "Nee"
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "boxed" },
                                      [
                                        _c(
                                          "w-col",
                                          { attrs: { xs: "12" } },
                                          [
                                            _c("h4", [_vm._v("Instellingen:")]),
                                            _c("app-select-department", {
                                              attrs: {
                                                value: _vm.ticket.departmentId,
                                                fancy: "",
                                                label: "Afdeling",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.setDepartment(
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _c("app-ticket-status-select", {
                                              staticClass: "mt",
                                              attrs: {
                                                value: _vm.ticket.statusId,
                                                fancy: "",
                                                label: "Status",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.setStatus($event)
                                                },
                                              },
                                            }),
                                            _c("app-admin-select", {
                                              staticClass: "mt",
                                              attrs: {
                                                value: _vm.assignedAdmins,
                                                fancy: "",
                                                label: "Toegewezen aan",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.setAssignedAdmins(
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _c("app-ticket-select-priority", {
                                              staticClass: "mt",
                                              attrs: {
                                                value: _vm.ticket.priority,
                                                fancy: "",
                                                label: "Prioriteit",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.setTicketPriority(
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "boxed" },
                                      [
                                        _c("h4", [_vm._v("Notities")]),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.companyVars.Notes,
                                              expression: "companyVars.Notes",
                                            },
                                          ],
                                          staticClass: "notes-textarea",
                                          attrs: {
                                            placeholder:
                                              "Notities over deze klant...",
                                            rows: "6",
                                          },
                                          domProps: {
                                            value: _vm.companyVars.Notes,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.companyVars,
                                                "Notes",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "w-button",
                                          {
                                            staticClass: "mts",
                                            on: {
                                              click: function ($event) {
                                                return _vm.saveCompanyNotes()
                                              },
                                            },
                                          },
                                          [_vm._v("Opslaan")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.toggleCrm
                                ? _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-link",
                                        {
                                          on: {
                                            click: function ($event) {
                                              _vm.toggleCrm = false
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "arrow-left" },
                                          }),
                                          _vm._v(" Terug "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "boxed mt" },
                                        [
                                          _c(
                                            "w-col",
                                            { attrs: { xs: "12" } },
                                            [
                                              _c("app-ticket-crm", {
                                                attrs: { company: _vm.company },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  attrs: { "escape-close": "" },
                  model: {
                    value: _vm.showModuleModal,
                    callback: function ($$v) {
                      _vm.showModuleModal = $$v
                    },
                    expression: "showModuleModal",
                  },
                },
                [
                  _c(
                    "w-card",
                    { attrs: { "max-width": "700" } },
                    [
                      _c("w-card-title", [_vm._v("Modules")]),
                      _c("w-card-content", [
                        _vm._v(" " + _vm._s(_vm.modulesAsString) + " "),
                      ]),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showModuleModal = false
                                },
                              },
                            },
                            [_vm._v(" Sluit ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  attrs: { "escape-close": "" },
                  model: {
                    value: _vm.showTimeSheduledModal,
                    callback: function ($$v) {
                      _vm.showTimeSheduledModal = $$v
                    },
                    expression: "showTimeSheduledModal",
                  },
                },
                [
                  _c(
                    "w-card",
                    { attrs: { "max-width": "500" } },
                    [
                      _c("w-card-title", [_vm._v("Planning")]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-col",
                            {
                              style: { display: "flex", flexDirection: "row" },
                            },
                            [
                              _c("w-date-picker", {
                                style: { flexGrow: "1", marginRight: "10px" },
                                attrs: { fancy: "", label: "Datum planning" },
                                model: {
                                  value: _vm.date,
                                  callback: function ($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date",
                                },
                              }),
                              _c("w-input-time", {
                                style: { minWidth: "120px" },
                                attrs: {
                                  fancy: "",
                                  label: "Tijdstip planning",
                                  step: "900",
                                },
                                model: {
                                  value: _vm.time,
                                  callback: function ($$v) {
                                    _vm.time = $$v
                                  },
                                  expression: "time",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showTimeSheduledModal = false
                                },
                              },
                            },
                            [_vm._v(" Sluit ")]
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              style: { marginRight: "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeShedule()
                                },
                              },
                            },
                            [_vm._v(" Verwijder planning ")]
                          ),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.saveShedule()
                                },
                              },
                            },
                            [_vm._v(" Opslaan ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  attrs: { "escape-close": "" },
                  model: {
                    value: _vm.addAutoMessage,
                    callback: function ($$v) {
                      _vm.addAutoMessage = $$v
                    },
                    expression: "addAutoMessage",
                  },
                },
                [
                  _c("app-ticket-reply-template-button", {
                    attrs: { ticket: _vm.ticket },
                    on: {
                      close: function ($event) {
                        _vm.addAutoMessage = false
                      },
                      "add-text": function ($event) {
                        return _vm.addTemplateText($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  attrs: {
                    value: _vm.onPasteToSendFiles.length > 0,
                    "escape-close": "",
                  },
                  on: {
                    input: function ($event) {
                      _vm.onPasteToSendFiles = []
                    },
                  },
                },
                [
                  _c("app-ticket-paste-attachment-preview", {
                    attrs: {
                      files: _vm.onPasteToSendFiles,
                      ticket: _vm.ticket,
                    },
                    on: {
                      "send-files": function ($event) {
                        return _vm.sendFiles($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.showPeppolActivationModal,
                    callback: function ($$v) {
                      _vm.showPeppolActivationModal = $$v
                    },
                    expression: "showPeppolActivationModal",
                  },
                },
                [
                  _c("app-peppol-activation-modal", {
                    attrs: {
                      title: "PEPPOL activeren",
                      ticket: _vm.ticket,
                      "dossier-id": _vm.ticket.dossierId,
                    },
                    on: {
                      saved: function ($event) {
                        return _vm.peppolActivated()
                      },
                      close: function ($event) {
                        _vm.showPeppolActivationModal = false
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.editSubjectModal
                ? _c("app-ticket-edit-subject-modal", {
                    attrs: { ticket: _vm.ticket },
                    on: {
                      close: function ($event) {
                        _vm.editSubjectModal = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }